import { render, staticRenderFns } from "./editAppointmentDates.vue?vue&type=template&id=0c554aec&scoped=true"
import script from "./editAppointmentDates.vue?vue&type=script&lang=js"
export * from "./editAppointmentDates.vue?vue&type=script&lang=js"
import style0 from "./editAppointmentDates.vue?vue&type=style&index=0&id=0c554aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c554aec",
  null
  
)

export default component.exports